import React from 'react';
import moment from 'moment';
import { differenceInDays } from 'date-fns';
import { DateFormats } from 'constants/common';
import { Stack, Tooltip, Typography } from '@mui/material';

import { ReportsListingViewModel } from '../../../types';

interface Props {
  row: ReportsListingViewModel;
}

export const CreatedCell = ({ row }: Props) => {
  return (
    <Stack>
      <Tooltip title={<Typography>{moment(row.createdDateTime).format(DateFormats.DateTimeMedium24Hour)}</Typography>}>
        <Typography>{moment(row.createdDateTime).format(DateFormats.MonthDay)}</Typography>
      </Tooltip>

      <Typography variant="caption" color="textDisabled">
        {differenceInDays(new Date(), new Date(row.createdDateTime))} days
      </Typography>
    </Stack>
  );
};
